import constant from "../../constant";
import axios from "axios";
import router from "../../router";

const api = constant.api + "histories";

const state = () => ({
  all: [],
  orderHistories: [],
  saleHistories: [],
  currentOrderHistory: {},
  currentSaleHistory: {},
});

// =====================
// GETTERS
// =====================
const getters = {
  getAll: (state) => state.all,
  getOrderHistories: (state) => state.orderHistories,
  getSaleHistories: (state) => state.saleHistories,
  getOrderHistory: (state) => state.currentOrderHistory,
  getSaleHistory: (state) => state.currentSaleHistory,
};

// =====================
// ACTIONS
// =====================
const actions = {
  // Fetch all order histories
  async fetchOrderHistories({ commit }) {
    await axios
      .get(`${api}_orders`)
      .then((response) => {
        commit("setOrderHistories", response.data);
      })
      .catch((error) => {
        console.error("Error fetching order histories:", error);
        throw error;
      });
  },

  // Fetch all sale histories
  async fetchSaleHistories({ commit }) {
    await axios
      .get(`${api}_sales`)
      .then((response) => {
        commit("setSaleHistories", response.data);
      })
      .catch((error) => {
        console.error("Error fetching sale histories:", error);
        throw error;
      });
  },

  // Fetch single order history by reference
  async fetchOrderHistory({ commit }, reference) {
    await axios
      .get(`${api}_orders/${reference}`)
      .then((response) => {
        commit("setCurrentOrderHistory", response.data);
      })
      .catch((error) => {
        console.error("Error fetching order history:", error);
        throw error;
      });
  },

  // Fetch single sale history by reference
  async fetchSaleHistory({ commit }, reference) {
    await axios
      .get(`${api}_sales/${reference}`)
      .then((response) => {
        commit("setCurrentSaleHistory", response.data);
      })
      .catch((error) => {
        console.error("Error fetching sale history:", error);
        throw error;
      });
  },

  // Clear current order history
  clearOrderHistory({ commit }) {
    commit("clearCurrentOrderHistory");
  },

  // Clear current sale history
  clearSaleHistory({ commit }) {
    commit("clearCurrentSaleHistory");
  },
};

// =====================
// MUTATIONS
// =====================
const mutations = {
  setOrderHistories(state, data) {
    state.orderHistories = data;
    state.all = [...data]; // optional: set `all` to current data
  },
  setSaleHistories(state, data) {
    state.saleHistories = data;
    state.all = [...data]; // optional: set `all` to current data
  },
  setCurrentOrderHistory(state, data) {
    state.currentOrderHistory = data;
  },
  setCurrentSaleHistory(state, data) {
    state.currentSaleHistory = data;
  },
  clearCurrentOrderHistory(state) {
    state.currentOrderHistory = {};
  },
  clearCurrentSaleHistory(state) {
    state.currentSaleHistory = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
